import { z } from "zod";

export const registerInfoResponseSchema = z.object({
  q: z.string(),
  name: z.string(),
  mobilePhoneNo: z.string().optional(),
  playncId: z.string(),
});

export type RegisterInfoResponseType = z.infer<typeof registerInfoResponseSchema>;
